import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'mri-datalist-item-description, [mriDatalistItemDescription]',
  standalone: true
})
export class DatalistItemDescriptionDirective {
  @HostBinding('class.mri-datalist__item-paragraph') readonly hostClass = true;
}
